<template>
  <div class="generic-tile">
    <div class="radio-selection"></div>
    <div class="wrapp-first">
      <slot name="first"></slot>
    </div>
    <div class="wrapp-content">
      <slot name="content"></slot>
    </div>
    <div class="wrapp-last">
      <slot name="last"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTabTile'
}
</script>
